import React from 'react';
import { observer } from 'mobx-react';
import { computed } from 'mobx';
import { AppUI } from '@seedlang/state';
import styled from '@emotion/styled';
import SettingsMenu from './settings_menu';
import { isPresent } from '@seedlang/utils';
import { useOutlet } from 'react-router-dom';
import MobileSettingsHeader from 'components/layout/mobile/settings_header';

const Wrapper = styled.div`
  margin: ${props => props.margin};
  display: flex;
  flex-direction: ${props => props.flexDirection};
  gap: 15px;
  align-items: start;
  width: 100%;
  box-sizing: border-box;
`;

const ContentContainer = styled.div`
  flex: 1;
  margin: ${props => props.margin};
  padding: ${props => props.isMobile ? '10px' : '20px'};
  border-radius: ${props => props.borderRadius};
  overflow: hidden;
  background: white;
  width: 100%;
  box-sizing: border-box;
`;

const Content = styled.div`
  background: white;
  padding: ${props => props.isMobile ? 0 : '10px'};
  h3 {
    margin: 0 0 20px 0;
  }
`;
@observer
class Settings extends React.Component {

  @computed get flexDirection() {
    if (AppUI.layout.isDesktop) {
      return AppUI.siteIsSeedlang ? 'row' : 'row-reverse';
    }
    return 'column';
  }

  @computed get showMobileSettingsMenu() {
    return AppUI.layout.isMobile && AppUI.routeStore.routeName === 'settings.all';
  }

  componentDidMount() {
    if (!AppUI.userIsSignedInAndNotGuest) {
      AppUI.routeToHome();
    }
    if (!AppUI.layout.isMobile && AppUI.routeStore.routeName === 'settings.all') {
      AppUI.routeStore.routeToNamed('settings.user_profile');
    }
  }

  render() {
    return (
      <Wrapper
        flexDirection={this.flexDirection}
        margin={AppUI.layout.isMobile ? 0 : null}
      >
        {
          this.showMobileSettingsMenu &&
            <MobileSettingsHeader
              title='Settings'
              onBack={() => AppUI.routeStore.routeToNamed('more')}
            />
        }
        {
          !this.showMobileSettingsMenu && isPresent(this.props.content) &&
            <>
              {
                AppUI.layout.isMobile && AppUI.userIsSignedInAndNotGuest &&
                  <MobileSettingsHeader
                    title='Back to Settings'
                    onBack={() => AppUI.routeStore.routeToNamed('more')}
                  />
              }
              <ContentContainer
                borderRadius={AppUI.layout.isMobile ? 0 : '10px'}
                isMobile={AppUI.layout.isMobile}
              >
                <Content
                  isMobile={AppUI.layout.isMobile}
                >
                  {this.props.content}
                </Content>
              </ContentContainer>
            </>
        }
        {
          AppUI.userIsSignedInAndNotGuest && (AppUI.layout.isDesktop || this.showMobileSettingsMenu) &&
            <SettingsMenu {...this.props} />
        }
      </Wrapper>
    );
  }
}

export { Settings };

export default function SettingsRoute(props) {
  const content = useOutlet();

  return <Settings {...props} content={content} />;
}
